import React, { useState } from 'react';
import './App.css';
// Look & feel IBM Carbon (g10) sobre App.css
import './carbon.css';

// Hooks
import { useNotifications } from './hooks/useNotifications';
import { useAuth } from './hooks/useAuth';
import { useFileUpload } from './hooks/useFileUpload';
import { useSessionState } from './hooks/useSessionState';

// Components - Layout
import { Header } from './components/layout/Header';
import { Sidebar } from './components/layout/Sidebar';
import { NotificationBanner } from './components/layout/NotificationBanner';

// Components - Auth
import { LoginPage } from './components/auth/LoginPage';

// Módulos (rediseño 2026-05)
import { ProcesoModule } from './components/modules/ProcesoModule';
import { CompartirModule } from './components/modules/CompartirModule';
import { InformePublico } from './components/auth/InformePublico';
import { TbbcModule } from './components/modules/TbbcModule';
import { OptimizeModule } from './components/modules/OptimizeModule';
import { AxdModule } from './components/modules/AxdModule';
import { AreasModule } from './components/modules/AreasModule';
import { CostosCloudModule } from './components/modules/CostosCloudModule';
import { CostosProveedorModule } from './components/modules/CostosProveedorModule';
import { DistribucionModule } from './components/modules/DistribucionModule';
import { LiquidacionModule } from './components/modules/LiquidacionModule';

function App() {
  const { user, isAuthenticated, loading: authLoading, login, sendCode, loginWithCode, logout } = useAuth();
  const { notification, showNotification, clearNotification } = useNotifications();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeModule, setActiveModule] = useState('liquidacion');

  // Estado de la sesión Cloud elevado aquí (App se mantiene siempre montado)
  // para que el CSV cargado no se pierda al cambiar de pestaña y volver.
  const cloudUpload = useFileUpload(showNotification, 'cloud:upload');
  const [cloudMonth, setCloudMonth] = useSessionState('cloud:month', '');
  const [cloudTrm, setCloudTrm] = useSessionState('cloud:trm', '');

  // Enlace de gerencia (/informe/<token>): página pública, sin login
  const enlaceInforme = window.location.pathname.match(/^\/informe\/([\w-]+)\/?$/);
  if (enlaceInforme) return <InformePublico token={enlaceInforme[1]} />;

  // Verificación de autenticación
  if (authLoading) {
    return (
      <div className="login-container">
        <div className="login-card" style={{ textAlign: 'center', padding: '40px' }}>
          <p>Cargando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage onLogin={login} onSendCode={sendCode} onLoginWithCode={loginWithCode} />;
  }

  return (
    <div className="carbon-app">
      <NotificationBanner notification={notification} onClose={clearNotification} />
      <Header user={user} onLogout={logout} showNotification={showNotification} />

      <div className="app-layout">
        <Sidebar
          activeModule={activeModule}
          onModuleChange={setActiveModule}
          isCollapsed={sidebarCollapsed}
          onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        />

        <main className={`content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
          <div className="page-container">
            {activeModule === 'tbbc' ? (
              <TbbcModule showNotification={showNotification} />
            ) : activeModule === 'optimize' ? (
              <OptimizeModule showNotification={showNotification} />
            ) : activeModule === 'axd' ? (
              <AxdModule showNotification={showNotification} />
            ) : activeModule === 'areas' ? (
              <AreasModule showNotification={showNotification} />
            ) : activeModule === 'costos-cloud' ? (
              <CostosCloudModule showNotification={showNotification} />
            ) : activeModule === 'distribucion' ? (
              <DistribucionModule showNotification={showNotification} />
            ) : activeModule === 'liquidacion' ? (
              <LiquidacionModule showNotification={showNotification} />
            ) : activeModule === 'costos-proveedor' ? (
              <CostosProveedorModule showNotification={showNotification} />
            ) : activeModule === 'compartir' ? (
              <CompartirModule showNotification={showNotification} />
            ) : activeModule === 'proceso' ? (
              // Módulo Cloud viejo: oculto del menú (lo reemplazó Costos Cloud), se conserva por si hay que volverlo a mostrar
              <ProcesoModule
                showNotification={showNotification}
                fileUpload={cloudUpload}
                selectedMonth={cloudMonth}
                setSelectedMonth={setCloudMonth}
                trm={cloudTrm}
                setTrm={setCloudTrm}
              />
            ) : (
              <LiquidacionModule showNotification={showNotification} />
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
